var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"btnRow"}),_c('operationTable',{ref:"operationTable",attrs:{"tableData":_vm.tableData},on:{"defaultsize":_vm.changeSize,"defaultpage":_vm.changeCurrent,"defaultcheck":_vm.changeSelection}}),_c('DailyLogDetail',{ref:"DailyLogDetail"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }